import React from "react";
import Layout from '../../NewComponent/LayoutAdmin/Layout';
import RestrictPermission from "../../Component/RestrictPermission/RestrictPermission";

function AdminRestrictPermission() {
  return (
    <Layout>
      <RestrictPermission />
    </Layout>
  );
}

export default AdminRestrictPermission;
